import { createEntityAdapter } from '@reduxjs/toolkit';
import { IPlenum } from 'application/components/api/Plenum';

export const plenumAdapter = createEntityAdapter<IPlenum, number>({
  selectId: (project) => project.plenumID,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});
